import React, { useState, useEffect, useRef } from 'react';
import moment from "moment";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import airports from "../../Data/AirportList.json";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import DefaultData from '../../CompanyData/DefaultData';
import { useAuth } from '../../Common/Configurations/AuthContext';
const ModifyFlightSearch = ({onSearch}) => {
    const { user } = useAuth();
    const navigate = useNavigate();
    const { state } = useLocation();
    const [departureDate, setDepartureDate] = useState(new Date())
    const [returnDate, setReturnDate] = useState(new Date())
    const [departureResults, setDepartureResults] = useState([]);
    const [arrivalResults, setArrivalResults] = useState([]);
    const [locationFrom, setLocationFrom] = useState('HYD');
    const [locationTo, setLocationTo] = useState('BOM');
    const [displayFrom, setDisplayFrom] = useState('Hyderabad(HYD), India');
    const [displayTo, setDisplayTo] = useState('Mumbai(BOM), India');
    const [selectedDeparture, setSelectedDeparture] = useState(null);
    const [selectedArrival, setSelectedArrival] = useState(null);
    const [from, setFrom] = useState('Hyderabad, India');
    const [to, setTo] = useState('Mumbai, India');
    const [searchQuery, setSearchQuery] = useState({});
    const [trips, setTrips] = useState([
        { from: "HYD, India", to: "BOM, India", locationFrom: "HYD", locationTo: "BOM", displayFrom: "Hyderabad(HYD)", displayTo: "Mumbai(BOM)", cityFrom: "Hyderabad", cityTo: "Mumbai", departureDate: new Date(), departureResults: [], arrivalResults: [] },
    ]);
    const [adults, setAdults] = useState(1);
    const [kids, setKids] = useState(0);
    const [infants, setInfants] = useState(0);
    const [cabinClass, setCabinClass] = useState("ECONOMY");
    const [errors, setErrors] = useState({});
    const [journeyType, setJourneyType] = useState("ONEWAY");
    const inputDRef = useRef(null);
    const inputARef = useRef(null);

    const validate = () => {
        let temp = {};
        temp.from = from === "" ? false : true;
        temp.to = to === "" ? false : true;
        setErrors(temp);
        return Object.values(temp).every((x) => x === true);
    };
    const handleDepartureAirportSearch = (e) => {
        const value = e.target.value;
        setDisplayFrom(value);
        if (value.length > 0) {
            const lowerValue = value.toLowerCase();
            const filteredAirports = airports.filter(airport => airport.display === true && airport.airportCode.toLowerCase().includes(value.toLowerCase())).slice(0, 10);
            setDepartureResults(filteredAirports);
            if (filteredAirports.length === 0) {
                const filteredAirports1 = airports
                    .filter(airport =>
                        airport.airportCode.toLowerCase().includes(lowerValue) ||
                        airport.cityName.toLowerCase().includes(lowerValue) ||
                        airport.airportName.toLowerCase().includes(lowerValue) &&
                        (!selectedArrival || airport.airportCode !== selectedArrival.airportCode) // Exclude selected arrival
                    )
                    .slice(0, 10);
                setDepartureResults(filteredAirports1);
            }
        } else {
            setDepartureResults([]);
        }
    };
    const handleDepartureAirportClick = (e) => {
        setArrivalResults([]);
        let filteredAirports = airports.filter(function (p) {
            return p.display === true
        }).slice(0, 10);
        setDepartureResults(filteredAirports);
        inputDRef.current.select();
    };
    const handleDepartureSelect = (data) => {
        if (selectedArrival && selectedArrival.airportCode === data.airportCode) {
            alert("Departure and arrival airports cannot be the same.");
            setSelectedArrival(null);
            setDisplayTo(""); // Clear arrival input
            return;
        } else {
            var DF = data.cityName + "(" + data.airportCode + "), " + data.countryName;
            setDisplayFrom(DF);
            setLocationFrom(data.airportCode);
            setFrom(data.cityName);
            setSelectedDeparture(data);
            setDepartureResults([]);
        }
    }
    const handleArrivalAirportSearch = (e) => {
        const value = e.target.value;
        setDisplayTo(value);
        if (value.length > 0) {
            const lowerValue = value.toLowerCase();
            const filteredAirports = airports
                .filter(airport =>
                    airport.airportCode.toLowerCase().includes(lowerValue)
                )
                .slice(0, 10);
            setArrivalResults(filteredAirports);
            if (filteredAirports.length === 0) {
                const filteredAirports1 = airports
                    .filter(airport =>
                        airport.cityName.toLowerCase().includes(value.toLowerCase())
                    )
                    .slice(0, 10);
                setArrivalResults(filteredAirports1);
            }
        } else {
            setArrivalResults([]);
        }
    };
    const handleArrivalSelect = (data) => {
        if (selectedDeparture && selectedDeparture.airportCode === data.airportCode) {
            alert("Arrival and departure airports cannot be the same.");
            setSelectedDeparture(null);
            setDisplayFrom(""); // Clear departure input
            return;
        }
        else {
            var DF = data.cityName + "(" + data.airportCode + "), " + data.countryName;
            setDisplayTo(DF);
            setLocationTo(data.airportCode)
            setTo(data.cityName);
            setSelectedArrival(data);
            setArrivalResults([]);
        }
    }
    const handleArrivalAirportClick = (e) => {
        setDepartureResults([]);
        let filteredAirports = airports.filter(function (p) {
            return p.display === true
        }).slice(0, 10);
        setArrivalResults(filteredAirports);
        inputARef.current.select();
    };
    const handleClassType = (e) => {
        setCabinClass(e.target.value)
    }
    const handleIncreaseAdults = (e) => {
        e.stopPropagation();
        setAdults(parseFloat(adults + 1))
    }
    const handleDecreaseAdults = (e) => {
        e.stopPropagation();
        if (adults !== 1) {
            setAdults(parseFloat(adults - 1))
        }
    }
    const handleIncreaseKids = (e) => {
        e.stopPropagation();
        setKids(parseFloat(kids + 1))
    }
    const handleDecreaseKids = (e) => {
        e.stopPropagation();
        if (kids !== 0) {
            setKids(parseFloat(kids - 1))
        }
    }
    const handleIncreaseInfants = (e) => {
        e.stopPropagation();
        setInfants(parseFloat(infants + 1))
    }
    const handleDecreaseInfants = (e) => {
        e.stopPropagation();
        if (infants !== 0) {
            setInfants(parseFloat(infants - 1))
        }
    }
    const handleDepartureDate = (date) => {
        const selectedDate = date[0];
        setDepartureDate(selectedDate);

        // If returnDate is before the new departureDate, reset it to departureDate
        if (returnDate && selectedDate && returnDate < selectedDate) {
            setReturnDate(selectedDate);
        }
    };
    const handleReturnDate = (date) => {
        setReturnDate(date[0]);
    };
    const handleJourneyType = (e) => {
        e.preventDefault();
        setJourneyType(e.target.value);
    }
    function GetFlightDestinations() {
        const fvalues = [];
        for (var i = 0; i < trips.length; i++) {
            fvalues.push({ from: locationFrom, to: locationTo, departureDate: moment(departureDate).format('YYYY-MM-DD'), returnDate: moment(returnDate).format('YYYY-MM-DD') });
        }
        return fvalues;
    }
    const handleSearch = (e) => {
        e.preventDefault();
        if (validate()) {
            const searchQuery = {
                "journeyType": journeyType,
                "isDomestic": "DOMESTIC",
                "adults": adults,
                "kids": kids,
                "infants": infants,
                "cabinClass": cabinClass,
                "companyId": user?.isSupplierAPI === true ? user.cid : user.parentCompanyId,
                "preferred": "REGULAR",
                "isDirectFlight": false,
                "isConnectingFlight": false,
                "flightTravelerPoints": GetFlightDestinations(),
            }
            onSearch(searchQuery);
            navigate('/flight/' + adults + "/" + kids + "/" + infants + "/DOMESTIC", {
                replace: true,
                state: { searchQuery } 
            });
        }
    }
    useEffect(() => {
        console.log(state.searchQuery)
        setSearchQuery(state.searchQuery);
        setJourneyType(state.searchQuery.journeyType)
        setCabinClass(state.searchQuery.cabinClass)
        setAdults(state.searchQuery.adults);
        setKids(state.searchQuery.kids);
        setInfants(state.searchQuery.infants);
        const dAirports = airports.find(c => c.airportCode === state.searchQuery?.flightTravelerPoints[0]?.from)
        var DF = dAirports?.cityName + "(" + dAirports?.airportCode + "), " + dAirports?.countryName;
        setLocationFrom(dAirports?.airportCode)
        setDisplayFrom(DF)
        setFrom(dAirports?.cityName);
        const rAirports = airports.find(c => c.airportCode === state.searchQuery?.flightTravelerPoints[0]?.to)
        var DR = rAirports?.cityName + "(" + rAirports?.airportCode + "), " + rAirports?.countryName;
        setLocationTo(rAirports.airportCode)
        setDisplayTo(DR)
        setTo(rAirports.cityName);
        setDepartureDate(new Date(state.searchQuery?.flightTravelerPoints[0]?.departureDate))
        setReturnDate(new Date(state.searchQuery?.flightTravelerPoints[0]?.returnDate))
    }, []);
    return (
        <div className="card-body bg-dark text-white" style={{backgroundColor:DefaultData?.THEMECOLOR2}}>
            <div className="row">
                <div style={{ width: "12%", paddingRight:"2px" }}>
                    <label htmlFor="iconInput" className="form-label">Type</label>
                    <select className='form-select' value={journeyType} onChange={handleJourneyType} name="journeyType">
                        <option value={"ONEWAY"}>ONEWAY</option>
                        <option value={"RETURN"}>ROUNDTRIP</option>
                    </select>
                </div>
                <div style={{ width: "15%", paddingRight:"2px", paddingLeft:"2px" }}>
                    <label htmlFor="iconInput" className="form-label">FROM</label>
                    <div className="form-icon position-relative">
                        <input ref={inputDRef} className="form-control form-control-icon" type="text" placeholder="Search for an airport" value={displayFrom} onChange={handleDepartureAirportSearch} onClick={handleDepartureAirportClick} onFocus={handleDepartureAirportClick} />
                        <i className="ri-flight-takeoff-line" />
                    </div>
                    {errors.displayFrom === false ? (<div className="validationerror">Please select departure </div>) : ('')}
                    {departureResults.length > 0 && (
                        <ul className="locationListVideo scrollable-list" style={{ minWidth: "350px" }}>
                            {departureResults.map((airport) => (
                                <li className="locationListVideoItem" key={airport.airportCode} onClick={() => handleDepartureSelect(airport)}>
                                    <div className="item-name">{airport.cityName} ({airport.airportCode})</div>
                                    <div className="item-details">
                                        <span className="item-code-date">{airport.airportName}, </span>
                                        <span className="item-designation">{airport.countryName}</span>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
                <div style={{ width: "15%", paddingRight:"2px", paddingLeft:"2px" }}>
                    <label htmlFor="iconInput" className="form-label">TO</label>
                    <div className="form-icon position-relative">
                        <input ref={inputARef} className="form-control searchTextbox" type="text" placeholder="Search for an airport" value={displayTo} onChange={handleArrivalAirportSearch} onClick={handleArrivalAirportClick} onFocus={handleArrivalAirportClick} />
                        <i className="ri-flight-land-line" />
                    </div>
                    {arrivalResults.length > 0 && (
                        <ul className="locationListVideo scrollable-list" style={{ minWidth: "350px" }}>
                            {arrivalResults.map((airport) => (
                                <li className="locationListVideoItem" key={airport.airportCode} onClick={() => handleArrivalSelect(airport)}>
                                    <div className="item-name">{airport.cityName} ({airport.airportCode})</div>
                                    <div className="item-details">
                                        <span className="item-code-date">{airport.airportName}</span>
                                        <span className="item-designation">{airport.countryName}</span>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
                <div style={{ width: "13%", paddingRight:"2px", paddingLeft:"2px" }}>
                    <label htmlFor="iconInput" className="form-label">DEPARTURE DATE</label>
                    <div className="input-group">
                        <Flatpickr
                            value={departureDate}
                            onChange={date => handleDepartureDate(date)}
                            options={{ dateFormat: "d M Y", minDate: "today" }}
                            className={"form-control"}
                            placeholder="DEPARTURE DATE"
                        />
                        <div className="input-group-text bg-primary border-primary text-white">
                            <i className="ri-calendar-2-line"></i>
                        </div>
                    </div>
                </div>
                {journeyType === "RETURN" ?
                    <div style={{ width: "13%", paddingRight:"2px", paddingLeft:"2px" }}>
                        <label htmlFor="iconInput" className="form-label">RETURN DATE</label>
                        <div className="input-group">
                            <Flatpickr
                                value={returnDate}
                                onChange={date => handleReturnDate(date)}
                                options={{ dateFormat: "d M Y", minDate: departureDate, }}
                                className={"form-control"}
                                placeholder="RETURN DATE"
                            />
                            <div className="input-group-text bg-primary border-primary text-white">
                                <i className="ri-calendar-2-line"></i>
                            </div>
                        </div>
                    </div> : ''}
                <div style={{ width: "24%", paddingRight:"2px", paddingLeft:"2px" }}>
                    <label htmlFor="iconInput" className="form-label">TRAVELLERS & CLASS</label>
                    <div class="dropdown" data-bs-auto-close="outside">
                        <div class=" form-control w-100 dropdown-toggle" type="button" id="dropdownMenuButton"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            {adults + " Adults, " + kids + " Kids, " + infants + " Infants & " + cabinClass}
                        </div>
                        <div className="dropdown-menu p-3" aria-labelledby="dropdownMenuButton">
                            <div className="mb-3 d-flex justify-content-between align-items-center">
                                <span>Adults</span>
                                <div className="input-step d-flex align-items-center">
                                    <button type="button" className="minus" onClick={handleDecreaseAdults}>–</button>
                                    <input type="number" className="product-quantity text-center" min="1" max="9" readOnly value={adults} name="adults" />
                                    <button type="button" className="plus" onClick={handleIncreaseAdults}>+</button>
                                </div>
                            </div>
                            <div className="mb-3 d-flex justify-content-between align-items-center">
                                <span>Kids</span>
                                <div className="input-step d-flex align-items-center">
                                    <button type="button" className="minus" onClick={handleDecreaseKids}>–</button>
                                    <input type="number" className="product-quantity text-center" min="0" max="9" readOnly value={kids} name="kids" />
                                    <button type="button" className="plus" onClick={handleIncreaseKids}>+</button>
                                </div>
                            </div>
                            <div className="mb-3 d-flex justify-content-between align-items-center">
                                <span>Infants</span>
                                <div className="input-step d-flex align-items-center">
                                    <button type="button" className="minus" onClick={handleDecreaseInfants}>–</button>
                                    <input type="number" className="product-quantity text-center" min="0" max="5" readOnly value={infants} name="infants" />
                                    <button type="button" className="plus" onClick={handleIncreaseInfants}>+</button>
                                </div>
                            </div>
                            <div className="mb-3 d-flex justify-content-between align-items-center">
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="cabinClass" id="ECONOMY" onChange={e => handleClassType(e)} value="ECONOMY" checked={cabinClass === "ECONOMY" ? true : false}></input>
                                    <label class="form-check-label" for="inlineRadio1">REGULAR</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="cabinClass" id="BUSINESS" onChange={e => handleClassType(e)} value="BUSINESS" checked={cabinClass === "BUSINESS" ? true : false}></input>
                                    <label class="form-check-label" for="inlineRadio2">BUSINESS</label>
                                </div>
                            </div>
                            <div className="mb-3 d-flex justify-content-between align-items-center">
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="cabinClass" id="FIRST" onChange={e => handleClassType(e)} value="ECONOMY" checked={cabinClass === "FIRST" ? true : false}></input>
                                    <label class="form-check-label" for="inlineRadio2">FIRST</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="cabinClass" id="PREMIUM_ECONOMY" onChange={e => handleClassType(e)} value="PREMIUM_ECONOMY" checked={cabinClass === "PREMIUM_ECONOMY" ? true : false}></input>
                                    <label class="form-check-label" for="inlineRadio2">PREMIUM ECONOMY</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ width: "8%", paddingRight:"2px", paddingLeft:"2px" }}>
                    <button type="button" onClick={handleSearch} className="w-100 btn btn-danger" style={{marginTop:"28px"}}>
                        <i className="ri-search-line align-middle me-2"></i></button>
                </div>
            </div>
        </div>
    );
};

export default ModifyFlightSearch;
